import { render, staticRenderFns } from "./middleschool-pricing.vue?vue&type=template&id=cfb6f07a&"
import script from "./middleschool-pricing.vue?vue&type=script&lang=js&"
export * from "./middleschool-pricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports